module.exports = __webpack_public_path__ + "img/icon_pagination_next.e3824247.svg";